import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { BModal } from 'bootstrap-vue';
import TemplateRelationDetailsModalItem from './item/TemplateRelationDetailsModalItem.vue';
import { ITemplateRelationDetails, IProduct } from '@/typings/templateRelationDetails/templateRelationDetails';


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateRelationDetailsModal',
  props: {
    templateRelationDetails: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
    templateRelationDetails: ITemplateRelationDetails;
};





const iFrameUrl = process.env.VUE_APP_SHOPIFY_APP_URL;
const customilyBaseUrl = process.env.VUE_APP_CUSTOMILY_BASE_URL;

const getTitle = computed((): string => {
    return props.templateRelationDetails?.title;
});

const getProducts = computed(() => {
    return props.templateRelationDetails.Products.map((item) => {
        const client = props.templateRelationDetails?.Clients?.find((client) => client.client_id === item.client_id);
        return {
            title: item.product_title,
            src: item.image_src,
            published: item.published,
            active: item.active,
            url: `${customilyBaseUrl}/store/product/?product=${item.sp_product_id}&shop=${client?.client_actual_domain}`,
            childrens: getOptionSetsAndVariants(item)
        };
    });
});

const getOptionSetsAndVariants = (item: IProduct) => {
    const variations = [];
    for (const variation of item?.configuration?.variations || []) {
        if (variation.values?.length <= 0) {
            return [];
        }

        for (const value of variation.values) {
            if (value.product_id === null || value.product_id !== props.templateRelationDetails?.templateId) {
                continue;
            }
            const client = props.templateRelationDetails?.Clients?.find(
                (client) => client.client_id === item.client_id
            );
            variations.push({
                title: `${variation.name} > ${value?.value || 'N/A'}`,
                url: `${customilyBaseUrl}/store/product/?product=${item.sp_product_id}&shop=${client?.client_actual_domain}`,
                type: 'variant'
            });
        }
    }

    const optionSets = (item.configuration?.assignedSets || []).map((assignedSet) => {
        const optionSet = props.templateRelationDetails.OptionSets?.find(
            (optionSet) => optionSet.optionset_internal_id === assignedSet.id
        );
        if (!optionSet) {
            return [];
        }
        return (optionSet.options || []).map((option) => ({
            title: `${optionSet.optionset_name} > ${option.option_label ?? 'N/A'}`,
            url: `${iFrameUrl}/set?set=${optionSet.optionset_internal_id}`,
            type: 'option'
        }));
    });

    const flattenedOptionSets = optionSets.flat();

    return variations.concat(flattenedOptionSets);
};

const onCloseHandler = () => {
    emit('close');
};

return { __sfc: true,props, emit, iFrameUrl, customilyBaseUrl, getTitle, getProducts, getOptionSetsAndVariants, onCloseHandler, BModal, TemplateRelationDetailsModalItem }
}

})